import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { SharedModule } from "src/app/core/modules/shared.module";
import { LayoutRoutingModule } from "./layout.-routing.module";
import { LayoutComponent } from "./layout.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { FooterComponent } from "./footer/footer.component";
import { MenuComponent } from "./menu/menu.component";
import { MenuitemComponent } from "./menuitem/menuitem.component";
import { MenuProfileComponent } from "./menuprofile/menuprofile.component";
import { RightMenuComponent } from "./rightmenu/rightmenu.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { TopbarComponent } from "./topbar/topbar.component";

@NgModule({
    imports: [SharedModule, LayoutRoutingModule],
    declarations: [
        LayoutComponent,
        BreadcrumbComponent,
        MenuComponent,
        MenuitemComponent,
        MenuProfileComponent,
        RightMenuComponent,
        SidebarComponent,
        TopbarComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule { }
